// On-demand loaders for the hosted payment SDKs. These scripts define runtime
// globals (GlobalPayments / StaxJs) consumed only inside the card/ACH forms, so
// they are loaded lazily when a form mounts rather than render-blocking every
// admin page from the document head.

import loadScript from "@/lib/loadScript";

const GLOBAL_PAYMENTS_SRC =
  "https://js.paygateway.com/secure_payment/v1/globalpayments.js";
const STAX_SRC = "https://staxjs.staxpayments.com/stax.js";

export function loadGlobalPayments(): Promise<void> {
  return loadScript(GLOBAL_PAYMENTS_SRC);
}

export function loadStax(): Promise<void> {
  return loadScript(STAX_SRC);
}
